import { Injectable } from '@angular/core';


/**
 * This service handles guide list according to user products.
 */
@Injectable({ providedIn: 'root' })
export class GuideService { }
